module.exports = __webpack_public_path__ + "static/room3-c3e095a1625c9d039d96e3b7f871fcb6.jpg";